var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Views',{attrs:{"error":_vm.error,"loading":_vm.loading}},[_c('Logs',{on:{"loading":_vm.setLoading,"error":_vm.setError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }